export interface LifeAreaData {
  title: string;
  icon: string;
}

export interface LifeAreasData {
  [key: string]: LifeAreaData;
}

const lifeAreasData: LifeAreasData = {
  adventure: { title: "Adventure", icon: "🧗" },
  business: { title: "Business", icon: "🚀" },
  career: { title: "Career", icon: "🧑‍💼" },
  charity: { title: "Charity", icon: "🏥" },
  creativity: { title: "Creativity", icon: "🎨" },
  community: { title: "Community", icon: "🏫" },
  education: { title: "Education", icon: "📚" },
  environment: { title: "Environment", icon: "🌱" },
  health: { title: "Health", icon: "💚" },
  impact: { title: "Impact", icon: "🌍" },
  family: { title: "Family", icon: "👨‍👩‍👦‍👦" },
  finances: { title: "Finances", icon: "💰" },
  friendships: { title: "Friendships", icon: "🤝" },
  leisure: { title: "Leisure", icon: "🏖" },
  love: { title: "Love", icon: "👩‍❤️‍👨" },
  religion: { title: "Religion", icon: "🧎" },
  spirituality: { title: "Spirituality", icon: "💫" },
};

// ⛪
export default lifeAreasData;
